module.exports = __webpack_public_path__ + "img/bugu-logo.bb2f006e.svg";